import { createSlice } from '@reduxjs/toolkit';
import { PACS_URL } from '@custom/constant';

const initialState = {
  selectedImages: [],
}

// const convertToWadorsUrl = (inputString) => {
//   const regex = /studies-(.+?)-series-(.+?)-instances-(.+?)-frames-(\d+)\.png/;
//   const match = inputString.match(regex);

//   if (match) {
//     const [ , studyId, seriesId, instanceId, frameId ] = match;
//     return `wadors:${PACS_URL}/dcm4chee-arc/aets/DCM4CHEE/rs/studies/${studyId}/series/${seriesId}/instances/${instanceId}/frames/${frameId}`;
//   }
//   return null;
// };

const dwnldImgSlice = createSlice({
  name: 'report/imageSelection',
  initialState,
  reducers: {
    addImageforDwnld: (state, {payload}): void => {
      state?.selectedImages?.push(payload);
    },
    removeImageforDwnld: (state, {payload}): void => {
      const temp = state?.selectedImages?.filter(image => image !== payload);
      state.selectedImages = temp;
    },
    reset: (state): void => {
      state.selectedImages = [];
    }
  },
});

export const { addImageforDwnld, removeImageforDwnld, reset } = dwnldImgSlice.actions;
export default dwnldImgSlice.reducer;
